<script lang="ts">
	import { municipalities, provinces } from "./dutchCitiesAndTowns";

	export let placeName: string;
	export let municipalityIndex: number;
	export let provinceIndex: number;
</script>

<button
	type="button"
	class="flex w-full items-start gap-2 p-3 text-left transition-colors hover:bg-gray-50 focus:bg-gray-50 focus:outline-none"
	on:click
	on:blur
>
	<div class="flex flex-col">
		<span class="text-sm font-medium text-gray-900">
			{@html placeName}
		</span>
		<span class="text-xs text-gray-500">
			{municipalities[municipalityIndex]}, {provinces[provinceIndex]}
		</span>
	</div>
</button>
